/* eslint-disable @typescript-eslint/no-explicit-any */
import { useState } from 'react'
import {
  ToggleGroup,
  ToggleGroupItem
} from '~/components/UI/shadcn/toggle-group'
import { cn } from '~/lib/utils'

type ToggleProps = {
  type: 'multiple' | 'single'
  format: 'text' | 'icon'
  data: {
    id: string
    label: string
    icon?: string
  }[]
  className?: string
  itemClass?: string
  value?: string | string[]
  onValueChange?: (value: string | string[]) => void
}

const FormUIToggle = (props: ToggleProps) => {
  const { type, data, format, className, itemClass, value, onValueChange } =
    props
  const [activeTab, setActiveTab] = useState<string[]>([])

  const handleClick = (item: string) => {
    setActiveTab(prevState => {
      if (prevState.includes(item)) {
        return prevState.filter(i => i !== item)
      } else {
        return [...prevState, item]
      }
    })
  }

  const getIconSrc = (icon: string, isActive: boolean, isDark: boolean) => {
    const targetColor = isDark
      ? isActive
        ? '/single-colour/ink-blue/'
        : '/single-colour/white/'
      : isActive
        ? '/single-colour/white/'
        : '/single-colour/ink-blue/'

    return icon
      .replace('/single-colour/white/', targetColor)
      .replace('/single-colour/ink-blue/', targetColor)
  }

  const renderIconImages = (item: {
    id: string
    label: string
    icon?: string
  }) => {
    if (!item.icon) return null

    const isActive = activeTab.includes(item.id)

    return (
      <>
        <img
          src={getIconSrc(item.icon, isActive, true)}
          alt={item.label}
          className='h-s w-s hidden dark:flex'
        />
        <img
          src={getIconSrc(item.icon, isActive, false)}
          alt={item.label}
          className='h-s w-s dark:hidden'
        />
      </>
    )
  }

  const renderToggleItem = (item: {
    id: string
    label: string
    icon?: string
  }) => (
    <ToggleGroupItem
      key={item.id}
      value={item.id}
      className={cn(itemClass, '')}
      onClick={format === 'icon' ? () => handleClick(item.id) : undefined}
    >
      {format === 'text' ? item.label : renderIconImages(item)}
    </ToggleGroupItem>
  )

  return (
    <ToggleGroup
      type={type}
      className={className}
      value={value as any}
      onValueChange={onValueChange as any}
    >
      {data.map(renderToggleItem)}
    </ToggleGroup>
  )
}

export default FormUIToggle
